import axios from "axios";

// GET /privacy-policy returns `{ data: [{ id, policy }] }`.
export function extractPolicyRecord(responseData) {
  const records = responseData?.data;
  if (Array.isArray(records)) {
    return records[0] || null;
  }
  return records || null;
}

/** True when Quill/HTML (or plain text) has no meaningful content. */
export function isEmptyPolicyContent(html) {
  const text = String(html || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  return !text;
}

export function updatePolicy(data) {
  const token =localStorage.getItem("rfis");
  const jsonData = JSON.stringify(data);
  return axios.post(
    process.env.REACT_APP_BASE_URL + `api/v1/privacy-policy/`,
    jsonData,
    {
      headers: {
        rf_token_header123_k: token,
        "Content-Type": "application/json",
      },
    }
  );
}

export function getPolicy() {
  return axios.get(process.env.REACT_APP_BASE_URL + `api/v1/privacy-policy`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}
